import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';

const PEDRO_MAIN = 'https://www.pedrofleitas.com/';

const ArtesMarcialesPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <article className="bg-white pb-32 pt-56">
    <div className="container mx-auto max-w-3xl px-6">
      <Link to="/" className="mb-10 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-emerald-700 hover:text-emerald-900">
        <ArrowLeft size={16} /> Volver al inicio
      </Link>

      <h1 className="mb-4 text-4xl font-black tracking-tighter text-slate-900 md:text-5xl">Actividades marciales</h1>
      <p className="mb-12 text-lg text-slate-600">Información de Bujinkan, linaje y actividades del centro, sintetizada a partir de los materiales actualizados.</p>

      <div className="mb-16 rounded-3xl border border-emerald-100 bg-emerald-50/50 p-8">
        <h2 className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-emerald-800">Linaje</h2>
        <p className="mb-4 leading-relaxed text-slate-700">Se entiende como linaje la transmisión de conocimientos a través de la relación directa maestro-alumno.</p>
        <ol className="list-decimal space-y-2 pl-5 font-bold text-slate-900">
          <li>Sôke Masaaki Hatsumi</li>
          <li>Pedro Fleitas González</li>
          <li>Richard Atik</li>
        </ol>
      </div>

      <div className="mb-16 space-y-4 rounded-3xl border border-slate-100 bg-slate-50/80 p-8">
        <h2 className="text-lg font-black text-slate-900">Qué es la Bujinkan</h2>
        <p className="leading-relaxed text-slate-600">El Budô Taijutsu integra nueve linajes tradicionales (ryûha) y se orienta a la autoprotección y al desarrollo personal desde una práctica colaborativa, no competitiva.</p>
        <p className="leading-relaxed text-slate-600">Incluye trabajo de movimiento, golpeo, controles, proyecciones y armas tradicionales, preservado por el Dr. Masaaki Hatsumi en su transmisión del legado marcial japonés.</p>
        <p className="text-sm text-slate-500">Referencia principal: <a href={PEDRO_MAIN} className="font-semibold text-emerald-700 underline" target="_blank" rel="noreferrer">pedrofleitas.com</a>.</p>
      </div>

      <div className="mb-16 grid gap-8 md:grid-cols-2">
        <div className="rounded-3xl border border-slate-100 p-8">
          <h2 className="mb-3 text-lg font-black text-slate-900">Dr. Masaaki Hatsumi</h2>
          <p className="leading-relaxed text-slate-600">
            Sôke de Bujinkan y heredero de la transmisión de Toshitsugu Takamatsu. El sistema que se trabaja en
            Budô Taijutsu se mantiene en esa línea de legado tradicional y en una práctica orientada a la efectividad
            real, la adaptación y el desarrollo humano integral.
          </p>
        </div>
        <div className="rounded-3xl border border-slate-100 p-8">
          <h2 className="mb-3 text-lg font-black text-slate-900">Pedro Fleitas González</h2>
          <p className="leading-relaxed text-slate-600">
            Dai Shihan, discípulo directo del Dr. Masaaki Hatsumi y referente internacional en la difusión de
            Bujinkan Dojo. Fundador de Unryukai Budo Taijutsu. En su centro de Telde combina docencia marcial y formación terapéutica, y ha realizado
            más de un centenar de viajes de entrenamiento a Japón.
          </p>
        </div>
      </div>

      <div className="mb-16 rounded-3xl border border-slate-100 p-8">
        <h2 className="mb-4 text-lg font-black text-slate-900">Qué es Unryukai Budo Taijutsu</h2>
        <p className="mb-4 leading-relaxed text-slate-600">Proyecto de formación como línea continuista de las enseñanzas del Soke Masaaki Hatsumi.</p>
        <a href={PEDRO_MAIN} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-bold text-emerald-700 hover:text-emerald-900">Ver sitio oficial <ExternalLink size={14} /></a>
      </div>

      <div className="mb-16 rounded-3xl border border-slate-100 p-8">
        <h2 className="mb-4 text-lg font-black text-slate-900">Defensa y autoprotección para mujeres (Yosei Goshinjutsu)</h2>
        <p className="leading-relaxed text-slate-600">Clases específicas para mujeres jóvenes y adultas para adquirir técnicas de autoprotección cuerpo a cuerpo y con utensilios cotidianos (bolsos, llaves, móviles, etc.), reforzando autoestima y seguridad personal. Las clases son impartidas por una instructora.</p>
      </div>

      <div className="grid gap-8 md:grid-cols-2">
        <div className="rounded-3xl border border-slate-100 p-8">
          <h2 className="mb-3 text-lg font-black text-slate-900">Chi Kung (Qi Gong)</h2>
          <p className="leading-relaxed text-slate-600">Serie de movimientos que armoniza cuerpo, mente y emociones, coordinando respiración y meditación activa para desarrollar bienestar y paz interior.</p>
        </div>
        <div className="rounded-3xl border border-slate-100 p-8">
          <h2 className="mb-3 text-lg font-black text-slate-900">Yoga</h2>
          <p className="leading-relaxed text-slate-600">Filosofía de vida con posturas, respiración, relajación y meditación para incrementar el equilibrio cuerpo-mente.</p>
        </div>
      </div>

      <div className="mt-12 rounded-2xl border border-slate-100 bg-slate-50 p-6 text-sm text-slate-700">
        <p className="font-bold text-slate-900">Más información de referencia</p>
        <p className="mt-2">
          Puedes ampliar más información sobre la Unryukai y Pedro Fleitas en{' '}
          <a className="font-semibold text-emerald-700 underline" href={PEDRO_MAIN} target="_blank" rel="noreferrer">
            pedrofleitas.com
          </a>
          .
        </p>
      </div>
    </div>
  </article>
  );
};

export default ArtesMarcialesPage;
